import {sortBy} from 'lodash';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {sortChatSessionsByLastMessage} from '../../sorters/sortChatSessionsByLastMessage';

export const selectChatSessions = state => state.chat.listed;

export function useChatSessions({filter, sort = sortChatSessionsByLastMessage} = {}) {
    const chatSessions = useSelector(selectChatSessions);

    return useMemo(() => {
        let result = chatSessions ?? [];

        if (filter) result = result.filter(filter);
        if (sort) result = sortBy(result, sort);

        return result;
    }, [chatSessions, filter]);
}
